import { produce } from 'immer'
import {
  GET_USER_INVITE_SUCCESS_ACTION,
  GetUserInviteActions,
} from 'src/app/PeopleDetailFlyout/redux/peopleDetailFlyout.actions'
import {
  GET_INVITED_PEOPLE_SUCCESS,
  GetPeopleInvitedToOrgActions,
  REMOVE_ORGANIZATION_INVITE,
  RemoveOrganizationInviteActions,
} from 'src/app/PeopleInvitedToOrg/redux/peopleInvitedToOrg.actions'
import { OrgInviteResponse } from 'src/models/people.models'
import {
  INVITE_ORGANIZATION_SUCCESS,
  InviteOrganizationActions,
} from 'src/redux/actions/data/organizations.actions'

export interface InvitedToOrgState {
  listResponses: Record<string, OrgInviteResponse>
}

export const initialState: InvitedToOrgState = {
  listResponses: {},
}

export type Actions =
  | GetPeopleInvitedToOrgActions
  | GetUserInviteActions
  | InviteOrganizationActions
  | RemoveOrganizationInviteActions

const InvitedToOrgReducer = (
  state: InvitedToOrgState = initialState,
  action: Actions,
): InvitedToOrgState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_USER_INVITE_SUCCESS_ACTION:
      case GET_INVITED_PEOPLE_SUCCESS: {
        draft.listResponses = action.payload.organizationInvites.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }

      case INVITE_ORGANIZATION_SUCCESS: {
        draft.listResponses = action.payload.organizationInvites.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }

      case REMOVE_ORGANIZATION_INVITE: {
        draft.listResponses = Object.keys(draft.listResponses)
          .filter((id) => id !== action.payload)
          .reduce(
            (acc, curr) => ({
              ...acc,
              [curr]: draft.listResponses[curr],
            }),
            {},
          )
        return draft
      }
    }
  })
}

export default InvitedToOrgReducer
